import { render } from "./RoleEdit.vue?vue&type=template&id=8a480fee&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"

import "./RoleEdit.vue?vue&type=style&index=0&id=8a480fee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a480fee"]])

export default __exports__